module.exports = __webpack_public_path__ + "img/full-fridge-poet-1.35d590fe.jpg";